import { AdminAsideNav } from "../components/AdminAsideNav";
import { AdminHeader } from "../components/adminHeader";
import { AdminLogo } from "../components/AdminLogo";

export const AdminShell = ({ nav, routes, showLanguage }: AdminShellProps): JSX.Element => {
    return (
        <div className="columns is-gapless">
            <AdminLogo />
            <AdminAsideNav />
            <div className="column">
                <AdminHeader nav={nav} showLanguage={showLanguage} />

                <div className="p-5">{routes}</div>
            </div>
        </div>
    );
};

interface AdminShellProps {
    nav?: JSX.Element;
    routes: JSX.Element;
    showLanguage?: boolean;
}
